import React from 'react';
import { useParams } from 'react-router';
import { Card } from 'antd';
import PropTypes from 'prop-types';
import ApprovedDetail from './ApprovedDetail';

const ApprovalResultSection = ({ approvalRoute }) => {
  const { id } = useParams();
  return (
    approvalRoute && (
      <Card title="Approval">
        {approvalRoute.approvalSteps
          .filter((step) => {
            return step.sequence < approvalRoute.sequence;
          })
          .map((step) => (
            <ApprovedDetail
              step={step}
              key={`approval-${id}-${step.sequence}`}
            />
          ))}
      </Card>
    )
  );
};

ApprovalResultSection.defaultProps = {
  approvalRoute: {},
};

ApprovalResultSection.propTypes = {
  approvalRoute: PropTypes.object.isRequired,
};

export default ApprovalResultSection;
